export const sortAtoZ = (array: any[], sortString: string) => {
  return array.sort((a, b) => {
    return a[sortString].localeCompare(b[sortString]);
  });
};
